import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=11cf501a&scoped=true&lang=html&"
import script from "./Deliveries.vue?vue&type=script&lang=js&"
export * from "./Deliveries.vue?vue&type=script&lang=js&"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=11cf501a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cf501a",
  null
  
)

export default component.exports